<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">{{ title }}</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div class="modal-body" *nfLoader="loadingBasis" hsDraggable="modal-dialog">
  <span id="info">{{ generalWarning }}</span>
  <nf-table-layout
    class="bv-mv-transfer-table"
    [autoResizeGrid]="false"
    hideTitle
    [isSectionTitle]="false"
    [gridOptions]="gridOptions"
    [data]="mvtBasisSelectionRows"
    hideSearch
    hideClearAll
  >
  </nf-table-layout>
</div>
<div class="modal-footer" hsDraggable="modal-dialog">
  <div class="left-controls"></div>
  <div class="right-controls">
    <button nf-button="cancel" (click)="activeModal.dismiss()"></button>
    <button nf-button="primary" (click)="save()">Save</button>
  </div>
</div>
